import { render } from "./agencySlide5.vue?vue&type=template&id=54c89832&scoped=true"
import script from "./agencySlide5.vue?vue&type=script&lang=js"
export * from "./agencySlide5.vue?vue&type=script&lang=js"

import "./agencySlide5.vue?vue&type=style&index=0&id=54c89832&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c89832"]])

export default __exports__